<template>
  <div class="c-input-radio__wrap">
    <label
      class="c-input-radio__label"
      :class="[
        `-${kind}`,
        {
          '-checked': modelValue === value,
          '-disabled': disabled
        }
      ]"
    >
      <span
        class="c-input-radio__icon__wrap"
        :style="{
          borderColor: modelValue === value && kind === 'main' ? colorCode : ''
        }"
      >
        <input
          type="radio"
          :name="name"
          :value="value"
          :checked="modelValue === value"
          class="c-input-radio"
          :class="{
            'c-input-radio--error': error
          }"
          :disabled="disabled"
          @change="onChange"
        />
        <i
          class="c-input-radio__icon"
          v-show="modelValue === value"
          :style="{ backgroundColor: kind === 'main' ? colorCode : '' }"
        ></i>
      </span>
      <span class="c-input-radio__text">
        <slot></slot>
      </span>
    </label>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits, computed } from 'vue';
import commons from '@/common/store/modules/commons';

const props = defineProps({
  modelValue: [String, Number, Boolean] as unknown as () => string | number | boolean,
  name: { type: String, required: true },
  value: { type: [String, Number, Boolean], required: true },
  kind: { type: String, default: 'main' },
  error: { type: String, default: '' },
  disabled: { type: Boolean, default: false }
});
const emit = defineEmits(['update:modelValue']);

const colorCode = computed(() => commons?.colorCode);

function onChange() {
  emit('update:modelValue', props.value);
}
</script>

<style lang="scss" scoped>
.c-input-radio {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;

  &__icon {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: rem(10);
    height: rem(10);
    margin: auto;
    display: block;
    border-radius: 50%;
    background: $common-gray700;

    &__wrap {
      position: relative;
      width: rem(20);
      height: rem(20);
      border: px(2) solid #bdbdbd;
      border-radius: 50%;
      display: block;
    }
  }

  &__wrap {
    display: inline-block;
  }

  &__label {
    padding: rem(12) rem(16) rem(12) rem(4);
    display: flex;
    align-items: center;
    cursor: pointer;

    &.-disabled {
      opacity: 0.3;
      cursor: default;
    }
  }

  &__text {
    font-size: rem(14);
    line-height: (24/14);
    margin-left: rem(8);
  }

  &__label.-main &__text {
    color: $common-gray500;
  }
  &__label.-checked.-main &__text {
    color: $common-black-main;
    font-weight: bold;
  }

  &__label.-secondary &__text {
    color: $common-gray700;
  }
  &__label.-checked.-secondary &__icon__wrap {
    border-color: $common-gray700;
  }
}
</style>
